import * as T from '../constants/types';
import { saveUserSettings } from '../utils/userSettings';
import { throwError } from './throwNotification';

/**
 * Сохраняет пользовательские настройки: источник истины — атрибут Cognito, localStorage — кэш.
 * В redux настройки уходят независимо от результата записи в Cognito: интерфейс должен
 * отреагировать на действие пользователя сразу, а на этом устройстве настройка
 * останется рабочей и из кэша.
 * @param {Object} settings - настройки
 */
export const onChangeUserSettings = settings => async dispatch => {
    const { settings: saved, error } = await saveUserSettings(settings);
    dispatch({ type: T.SET_USER_SETTINGS, payload: saved });

    if (error) {
        dispatch(throwError(error, T.SET_USER_SETTINGS + T.ERROR));
    }
};
